import './styles/delivery-config-list-item.scss'

import React       from 'react'
import PropTypes   from 'prop-types'

export default class DeliveryConfigListItem extends React.Component {
  static propTypes = {
    node:    PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  renderHighlight = (title, message) => {
    return (
      <div className="item-highlight ui mini message">
        <div className="title">{ title }</div>
        <div className="message">{ message }</div>
      </div>
    )
  }

  handleClick = (event) => {
    event.preventDefault()
    
    this.props.history.push(`/delivery-config/${this.props.node.id}`)
  }

  render() {
    const { node } = this.props

    return (
      <div className="delivery-config-list-item" onClick={this.handleClick}>
        <div className="description">
          <a href="/">{ node.name }</a>
        </div>

        <div className="details">
          { node.sender   && this.renderHighlight('Sender',    node.sender.name )   }
          { node.dataType && this.renderHighlight('Data Type', node.dataType.name ) }

          { this.renderHighlight('Delivery Service', node.deliveryService ) }
        </div>
      </div>
    )
  }
}